var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14385_14819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.28564 3.63555H17.7141C17.1442 2.94551 16.4833 2.33359 15.7501 1.81738H4.24959C3.51643 2.33352 2.85553 2.94547 2.28564 3.63555Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.0009C0 10.3074 0.0145703 10.6104 0.0415625 10.91H19.9584C19.9854 10.6104 20 10.3074 20 10.0009C20 9.69434 19.9854 9.39129 19.9584 9.0918H0.0415625C0.0145703 9.39129 0 9.69434 0 10.0009Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.09086 14.5457H18.9099C19.2044 13.9696 19.4445 13.3614 19.6238 12.7275H0.376953C0.556211 13.3614 0.796445 13.9697 1.09086 14.5457Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.24959 18.1815H15.7501C16.4833 17.6652 17.1442 17.0533 17.714 16.3633H2.28564C2.85553 17.0532 3.51643 17.6652 4.24959 18.1815Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.376953 7.27324H19.6239C19.4446 6.63934 19.2044 6.03105 18.91 5.45508H1.0909C0.796484 6.03105 0.55625 6.63934 0.376953 7.27324Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.78174 1.81816H15.7494C14.1228 0.67293 12.1396 0 9.99912 0C8.69479 0 6.4083 0.67293 4.78174 1.81816Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.56494 5.4539H18.9092C18.5767 4.8034 18.1751 4.19406 17.7139 3.63574H9.56494V5.4539Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.56494 9.09062H19.9581C19.9019 8.46633 19.7888 7.85836 19.6232 7.27246H9.56494V9.09062Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.376016 12.7283H19.6229C19.7886 12.1425 19.9016 11.5345 19.9579 10.9102H0.0410156C0.0972656 11.5345 0.210313 12.1424 0.376016 12.7283Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.28516 16.3641H17.7136C18.1747 15.8057 18.5764 15.1964 18.9089 14.5459H1.08984C1.42238 15.1964 1.82402 15.8057 2.28516 16.3641Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9993 20.0008C12.1398 20.0008 14.123 19.3279 15.7496 18.1826H4.24902C5.87559 19.3279 7.85879 20.0008 9.9993 20.0008Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.376465 7.27273C0.210762 7.85867 0.0977539 8.4666 0.0415039 9.0909H9.99994V0C5.42259 0 1.56365 3.07547 0.376465 7.27273Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.95289 2.6084L6.60035 4.60117H8.6959L7.00066 5.83289L7.64809 7.82578L5.95289 6.59414L4.25762 7.82578L4.9052 5.83289L3.20996 4.60117H5.30539L5.95289 2.6084Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14385_14819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsa);
export default __webpack_public_path__ + "static/media/usa.2f456b7123b9223e2c0ef4ed10d0ee35.svg";
export { ForwardRef as ReactComponent };